import React, { PropsWithChildren } from 'react';
import { Box } from '@clariness/clarikit-react';
import { Flex } from '@clariness/flex';
import { SidebarNavButton, SidebarNavLink } from './components';

type SidebarProps = PropsWithChildren<{
  responsive?: boolean;
}>;

export const Sidebar = ({ children, responsive }: SidebarProps) => {
  return (
    <Box
      width={responsive ? { _: '100%', md: '298px' } : '298px'}
      style={{ flexShrink: responsive ? 0 : undefined }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '100%',
          height: '100%',
          mt: '1px',
          py: '41px',
          backgroundColor: 'hgl6',
        }}
      >
        {children}
      </Flex>
    </Box>
  );
};

Sidebar.NavButton = SidebarNavButton;
Sidebar.NavLink = SidebarNavLink;
